import React, { useCallback, useMemo, useState } from 'react';
import { ReactComponent as IconCircleRight } from '../../../../../../../assets/icons/icon_circle-chevron-right-fill.svg';
import { globalColors } from '../../../../../../../../_metronic/_assets/sass/custom/globalColors';
import { Button } from './styles';
import bancosBrasileiros from 'bancos-brasileiros';
import InputForm from '../../../../../../../components/InputForm';
import { AppAPIService } from '../../../../../../../services/AppAPIService';
import Swal from 'sweetalert2';
import { Grid } from '@material-ui/core';

const banksFromApi = bancosBrasileiros.map((banco) => ({
  label: banco.LongName,
  value: banco.LongName,
  bankDocument: banco.Document,
}));

const banksOptionsWithSelectAll = [
  { label: 'SELECIONAR TODOS', value: 'all' },
  ...banksFromApi,
];

export const BancosCadastradosSelect = ({ setIsLoading, setReload, reload }) => {
  let api = AppAPIService.getInstance();

  const [bankOptions, setBankOptions] = useState(banksOptionsWithSelectAll);
  const [banks, setBanks] = useState([]);
  const onChangeBank = (bank) => {
    if (!bank) {
      setBanks([]);
      setBankOptions(banksOptionsWithSelectAll);
      return;
    }

    if (bank.some((bank) => bank.value === 'all')) {
      setBanks([{ label: 'SELECIONAR TODOS', value: 'all' }]);
      setBankOptions([]);
      return;
    }

    if (bank?.length) {
      setBanks(bank);
      return;
    }
  };

  const onSubmit = useCallback(
    async (e) => {
      setIsLoading(true);
      e.preventDefault();
      try {
        setIsLoading(true);

        let banksData = []

        if (banks.some((bank) => bank.value === 'all')) {
          banksData = banksFromApi;
        } else {
          banksData = banks;
        }

        await api.makeHttpRequest({
          url: '/bank',
          method: 'POST',
          data: {
            banks: banksData.map((bank) => ({
              name: bank.value,
              document: bank.bankDocument,
            })),
          },
        });

        setIsLoading(false);
        setBanks('');

        Swal.fire({
          icon: 'success',
          title: 'Sucesso!',
          text: 'Banco cadastrado com sucesso',
        });

        setReload(!reload);
      } catch (error) {
        setIsLoading(false);

        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'Erro ao criar banco.',
        });
      } finally {
        setReload(!reload);
        setBankOptions(banksOptionsWithSelectAll);
        setIsLoading(false);
      }
    },
    [api, banks, reload, setIsLoading, setReload]
  );

  const isFormInvalid = useMemo(() => banks === '', [banks]);

  return (
    <Grid
      container
      style={{
        padding: '18px 0 9px',
      }}
    >
      <Grid sm={10} style={{ backgroundColor: 'white' }}>
        <InputForm
          type="text"
          isSelect
          options={bankOptions}
          name="name"
          placeholder="Digite o nome do Banco"
          label="Nome"
          value={banks}
          required
          onChange={onChangeBank}
          isClearable
          isMulti
          height="fit-content !important"
        />
      </Grid>
      <Grid
        sm={2}
        style={{
          padding: '0 18px',
        }}
      >
        <Button
          variant="primary"
          type="submit"
          color={globalColors.primaryColor2}
          onClick={onSubmit}
          disabled={isFormInvalid}
          title={isFormInvalid ? 'Salvar dados' : 'Verifique os campos'}
          // submitText={submitText}
        >
          <span className="text-light">
            Salvar <IconCircleRight />
          </span>
        </Button>
      </Grid>
    </Grid>
  );
};
